import { defineMessages } from 'react-intl';

export default defineMessages({
    injuredPerson: {
        id: 'wni.fnol.ho.views.incidentdetails.singleInjuryIncidentPopup.injuredPerson',
        defaultMessage: 'Injured Person'
    },
    addNewPerson: {
        id: 'wni.fnol.ho.views.incidentdetails.singleInjuryIncidentPopup.addNewPerson',
        defaultMessage: 'Add new person'
    },
    injuredPersonFirstName: {
        id: 'wni.fnol.ho.views.incidentdetails.singleInjuryIncidentPopup.InjuredPersonFirstName',
        defaultMessage: 'Injured Person First Name'
    },
    injuredPersonLastName: {
        id: 'wni.fnol.ho.views.incidentdetails.singleInjuryIncidentPopup.InjuredPersonLastName',
        defaultMessage: 'Injured Person Last Name'
    },
    injuriesDescription: {
        id: 'wni.fnol.ho.views.incidentdetails.singleInjuryIncidentPopup.injuriesDescription',
        defaultMessage: 'Injuries Description'
    },
    cancel: {
        id: 'wni.fnol.ho.views.incidentdetails.singleInjuryIncidentPopup.cancel',
        defaultMessage: 'Cancel'
    },
    save: {
        id: 'wni.fnol.ho.views.incidentdetails.singleInjuryIncidentPopup.save',
        defaultMessage: 'Save'
    }
})